import { render, staticRenderFns } from "./UiSearch.vue?vue&type=template&id=49857ac7"
import script from "./UiSearch.vue?vue&type=script&lang=js"
export * from "./UiSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports